import { Builder, withChildren } from '@builder.io/react';

import Gallery from './index';

const GalleryWithBuilderChildren = withChildren(Gallery);

Builder.registerComponent(GalleryWithBuilderChildren, {
  name: 'Gallery',
  inputs: [
    {
      name: 'tabItems',
      type: 'list',
      subFields: [
        { name: 'label', type: 'string' },
        { name: 'text', type: 'string' },
        { name: 'video', type: 'object', subFields: [{ name: 'src', type: 'string' }] },
        {
          name: 'image',
          type: 'object',
          subFields: [
            { name: 'src', type: 'file', allowedFileTypes: ['jpeg', 'png', 'svg'] },
            { name: 'alt', type: 'string' },
            { name: 'width', type: 'number' },
            { name: 'height', type: 'number' }
          ]
        },
        {
          name: 'bullets',
          type: 'list',
          subFields: [
            { name: 'title', type: 'string' },
            { name: 'text', type: 'richText' }
          ]
        },
        {
          name: 'caption',
          type: 'list',
          subFields: [
            {
              name: 'time',
              type: 'number'
            },
            {
              name: 'text',
              type: 'string'
            }
          ]
        }
      ]
    },
    {
      name: 'videoAutoPlay',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'gradientColor',
      type: 'string'
    }
  ]
});
